/**
 * Import project configuration
 *
 * @package ARS Webapp
 * @author René Schulze <schulze@thadeus-roth.de>
 */

export default _CONFIG;
